import React, { useContext } from 'react';
import VerifyRecoveryCodeForm from '../features/auth/pages/verify-recovery-code/VerifyRecoveryCodeForm';
import useVerifyRecoveryCodeRequest from '../features/auth/pages/verify-recovery-code/useVerifyRecoveryCodeRequest';
import useForgotPasswordRequest from '@/features/auth/pages/forgot-password/useForgotPasswordRequest';


const VerifyRecoveryCodePage = () => {
    const { verifyRecoveryCode } = useVerifyRecoveryCodeRequest();
    const { forgotPassword: resendCode } = useForgotPasswordRequest();

    return (
        <VerifyRecoveryCodeForm 
            onVerifyRecoveryCodeSubmit={verifyRecoveryCode}
            resendCode={resendCode}
        />
    )
}

export default VerifyRecoveryCodePage;